module.exports = __webpack_public_path__ + "img/bg.4ac06e71.png";